<template>
	<div class="AppMarketingEvent">
		<div class="form-section">
			<div class="rows pt-4">
				<div class="inner-div">
					<label>
						Event Title / Campaign Title
					</label>
					<el-select
						v-model="value"
						placeholder="choose Title/Type"
						class="p-2 pr-4 mr-2"
					>
						<el-option
							v-for="item in 5"
							:key="item.value"
							:label="item"
							:value="item"
						/>
					</el-select>
				</div>
			</div>

			<div class="rows ">
				<div class="inner-div">
					<label>
						Is this applicable across all stores
					</label>
					<div class="div-flex">
						<input type="radio" class="m-2 radio-btn" />
						All
					</div>
				</div>
				<div class="inner-div">
					<label>
						Choose Locations
					</label>
					<el-select
						v-model="value"
						placeholder="Locations"
						class="p-2 pr-4 mr-2"
					>
						<el-option
							v-for="item in 5"
							:key="item.value"
							:label="item"
							:value="item"
						/>
					</el-select>
				</div>
			</div>

			<div class="rows ">
				<div class="inner-div">
					<label>
						Is this applicable across all products
					</label>
					<div class="div-flex">
						<input type="radio" class="m-2 radio-btn" />
						All
					</div>
				</div>
				<div class="inner-div">
					<label>
						Choose Locations
					</label>
					<div class="inner-div">
						<el-select
							v-model="value"
							placeholder="choose products"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
						<el-select v-model="value" placeholder="Size" class="p-2 pr-4 mr-2">
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
					</div>
				</div>
			</div>

			<div class="rows ">
				<div class="inner-div">
					<label>
						Launch Period
					</label>
					<div class="sub-section">
						<div class="date-picker ml-8">
							Start Date :
							<el-date-picker
								v-model="value1"
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
						<div class="date-picker  ml-8">
							End Date :
							<el-date-picker
								v-model="value1"
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="rows">
				<div class="inner-div">
					<label>
						Is this a new event or repeat
					</label>
					<div class="div-flex">
						<input
							type="radio"
							name="action"
							value="yes"
							class="m-2 radio-btn"
						/>Yes
					</div>
					<div class="div-flex">
						<input
							type="radio"
							name="action"
							value="no"
							class="m-2 radio-btn"
						/>No
					</div>
				</div>
			</div>

			<div class="rows ">
				<div class="inner-div">
					<label>
						Reference Event
					</label>
					<el-select
						v-model="value"
						placeholder="choose Title/Type"
						class="p-2 pr-4 mr-2"
					>
						<el-option
							v-for="item in 5"
							:key="item.value"
							:label="item"
							:value="item"
						/>
					</el-select>
				</div>
			</div>

			<div class="rows ">
				<div class="inner-div">
					<label>
						Launch Location
					</label>
					<div class="div-flex">
						<input type="radio" class="m-2 radio-btn" />All
					</div>
				</div>
				<div class="inner-div">
					<label>
						Choose Locations
					</label>
					<el-select
						v-model="value"
						placeholder="choose Title/Type"
						class="p-2 pr-4 mr-2"
					>
						<el-option
							v-for="item in 5"
							:key="item.value"
							:label="item"
							:value="item"
						/>
					</el-select>
				</div>
			</div>

			<div class="rows ">
				<div class="inner-div">
					<label>
						Event Period
					</label>
					<div class="sub-section">
						<div class="date-picker  ml-8">
							Start Date :
							<el-date-picker
								v-model="value1"
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
						<div class="date-picker  ml-8">
							End Date :
							<el-date-picker
								v-model="value1"
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="rows margin-top-bottom my-2">
				<div class="inner-div">
					<label>
						Reference Article Sales
					</label>
					<div class="sub-section">
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
					</div>
				</div>
			</div>

			<div class="rows margin-top-bottom my-2">
				<div class="inner-div">
					<label>
						Forecast
					</label>
					<div class="sub-section">
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
					</div>
				</div>
			</div>

			<div class="rows margin-top-bottom my-2">
				<div class="inner-div">
					<label>
						If a new event add a projection
					</label>
					<div class="sub-section">
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
					</div>
				</div>
			</div>

			<div class="rows ">
				<div class="inner-div">
					<label>
						Approve Forecast
					</label>
					<div class="text-left ml-2">
						<el-checkbox v-model="checked" class="m-2">
							Approve
						</el-checkbox>
					</div>
				</div>
				<!-- <div class="inner-div">
          <div class="sub-section">
            <label>
              Edit and approve forecast
            </label>
            <div class="ml-4">
              <input
                type="text"
                class="custom-input"
              >
            </div>
            <div class="ml-4">
              <input
                type="text"
                class="custom-input"
              >
            </div>
          </div>
        </div> -->
				<div class="inner-div">
					<label>
						Edit and approve forecast
					</label>
					<div class="sub-section">
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
						<div class="ml-4">
							<input type="text" class="custom-input" />
						</div>
					</div>
				</div>
			</div>

			<button class="save-btn">
				Save Forecast
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppMarketingEvent",
	mixins: [],
	props: [],
	data() {
		return {
			value: "",
			value1: "",
			checked: false
		};
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
@import "./AppMarketingEvent.scss";
</style>
<style>
.AppMarketingEvent .el-input__inner {
	border: 1px solid #c8c8c8;
	border-radius: 20px;
}
.AppMarketingEvent .date-picker .el-input__inner {
	border: 1px solid #c8c8c8;
	border-radius: 4px;
}
.AppMarketingEvent .el-checkbox__inner {
	width: 18px;
	height: 18px;
}
.AppMarketingEvent .el-checkbox__label {
	padding-left: 10px;
	font-size: 18px;
}
.AppMarketingEvent .el-checkbox__inner::after {
	height: 11px;
	left: 6px;
}
.AppMarketingEvent .date-picker .el-input__icon {
	padding: 8px 0 0px 13px;
}
.AppMarketingEvent .el-input--suffix .el-input__inner {
	padding-right: 20px;
	/* width: 234px; */
}
</style>
